import * as Icons from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { adapter } from "@/services/db";
import { useNotifications } from "@/context/NotificationsContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function Topbar({ onMenu }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [sys, setSys] = useState(null);
  useEffect(() => { const u = adapter.subscribeDoc("system_status", "global", setSys); return () => u && u(); }, []);
  const maintenance = sys && sys.master_enabled === false;
  const unseen = useNotifications().unseenBySection.notifications || 0;

  return (
    <header className="sticky top-0 z-20 h-16 border-b border-border bg-card/90 backdrop-blur-md flex items-center gap-3 px-4 sm:px-6">
      <button className="lg:hidden text-muted-foreground" onClick={onMenu} data-testid="menu-toggle">
        <Icons.Menu className="h-5 w-5" />
      </button>

      <img src="/brugo-logo.png" alt="Brugo" className="h-7 w-auto lg:hidden" />

      {maintenance && (
        <button onClick={() => nav("/system")} className="hidden sm:flex items-center gap-1.5 rounded-full border border-amber-300 bg-amber-50 px-3 py-1 text-xs font-medium text-amber-800" data-testid="maintenance-indicator">
          <Icons.TriangleAlert className="h-3.5 w-3.5" /> Maintenance mode ON
        </button>
      )}

      <div className="ml-auto flex items-center gap-2">
        <button onClick={() => nav("/notifications")} className="relative flex h-9 w-9 items-center justify-center rounded-lg text-muted-foreground hover:bg-accent hover:text-foreground transition-colors" data-testid="notifications-btn">
          <Icons.Bell className="h-[18px] w-[18px]" />
          {unseen > 0 && <span data-testid="topbar-notif-count" className="absolute -top-0.5 -right-0.5 min-w-4 h-4 px-1 rounded-full bg-red-600 text-white text-[9px] font-bold flex items-center justify-center ring-2 ring-card">{unseen > 99 ? "99+" : unseen}</span>}
        </button>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="ml-1 flex items-center gap-2 rounded-lg px-2 py-1.5 hover:bg-accent transition-colors" data-testid="user-menu">
              <div className="h-8 w-8 rounded-full bg-primary/15 text-primary flex items-center justify-center text-xs font-semibold">
                {(user?.name || "U").split(" ").map((n) => n[0]).slice(0, 2).join("")}
              </div>
              <div className="hidden sm:block text-left leading-tight">
                <p className="text-xs font-medium text-foreground">{user?.name}</p>
                <p className="text-[10px] font-mono uppercase text-muted-foreground">{user?.role}</p>
              </div>
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48">
            <DropdownMenuLabel>{user?.email}</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem data-testid="logout-btn" onClick={logout} className="text-destructive">
              <Icons.LogOut className="h-4 w-4 mr-2" /> Sign out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
